import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  AfterViewInit
} from '@angular/core';
import { OsusumeService } from '../../services/osusume.service';
import { OsusumeCategory } from '../../models/plan/osusume';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-osusume-add',
  templateUrl: './osusume-add.component.html',
  styleUrls: ['./osusume-add.component.css']
})
export class OsusumeAddComponent implements OnInit, AfterViewInit {
  @Input('categoryNo') categoryNo: number;
  @Input('oldName') oldName: string;
  @Output('close') close: any = new EventEmitter();
  public planName = '';
  public kyotenCd: string;
  public displayError = false;
  public isAdd = true;
  constructor(private osusumeSv: OsusumeService, private _data: DataService) {}

  ngOnInit() {
    this.kyotenCd = this._data.kyotenCd;
    if (this.oldName) {
      this.isAdd = false;
      this.planName = this.oldName;
    }

    if (this.isAdd) {
      this.categoryNo = this.osusumeSv.listCategory.length + 1;
    }
  }

  ngAfterViewInit() {
    this.focusInput(true);
  }

  focusInput(isSelect: boolean) {
    const inputName = <HTMLInputElement>(
      document.getElementById('txt-osusumenm')
    );
    if (inputName) {
      inputName.focus();
      if (isSelect) {
        setTimeout(function() {
          inputName.select();
        }, 50);
      }
    }
  }

  onOK() {
    if (this.planName != null && this.planName !== '') {
      if (!this.isAdd) {
        let value: OsusumeCategory = {};
        value.categoryTitle = this.planName;
        this.osusumeSv
          .updateCategory(this.kyotenCd, this.categoryNo, value)
          .subscribe(
            isSuccess => {
              if (isSuccess) {
                this.osusumeSv.loadCategory.next(true);
              }
              this.close.emit();
            },
            err => {
              if (err.status) {
                alert(err.message);
              } else {
                if (Number(err.rsltCode.substr(1, 4)) >= 500) {
                  alert('システムエラーが発生しました。');
                } else if (Number(err.rsltCode.substr(1, 4)) >= 400) {
                  alert(err.rsltComment);
                }
              }
            }
          );
      }
    } else {
      this.focusInput(false);
    }
  }

  onCancel() {
    this.close.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/osusume/osusume-add/osusume-add.component.ts